<template>
  <div class="w-full d-flex flex-wrap pa-3">
    <OCapCont class="w-1/2 pa-3" label="Login" :value="row.login" />
    <OCapCont class="w-1/2 pa-3" label="Nome completo" :value="row.name" />
    <OCapCont class="w-full pa-3" label="Email" :value="row.email" />
    <OCapCont class="w-full pa-3" label="Celular" :value="row.phone" />

    <!-- <OCapCont class="w-full pa-2" label="Tags">
      <OTagList :value="row.tags" />
    </OCapCont> -->

    <!-- <OCapCont
      class="w-full pa-3"
      label="Observações"
      :value="row.comments || '─'"
    /> -->

    <OCapCont
      class="w-1/2 pa-3"
      label="Criado em"
      :value="row.createdAt | moment('YYYY-MM-DD HH:mm')"
    />

    <OCapCont
      class="w-1/2 pa-3"
      label="Atualizado em"
      :value="row.updatedAt | moment('YYYY-MM-DD HH:mm')"
    />

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar Informações</v-btn>
    </div>

    <ODialog ref="dialog" :maxWidth="400">
      <v-card>
        <ODialogBar title="Editar Detalhes" @close="dismiss" />
        <v-card-text class="d-flex flex-wrap pa-3">
          <v-form ref="theForm" v-model="isValid" class="w-full">
            <OTextField
              class="w-full pa-3"
              label="Login"
              v-model="clonedValues.login"
            />
            <OTextField
              class="w-full pa-3"
              label="Nome completo"
              v-model="clonedValues.name"
            />
            <OTextField
              class="w-full pa-3"
              label="Email"
              v-model="clonedValues.email"
            />
            <OTextField
              class="w-full pa-3"
              label="Celular"
              v-model="clonedValues.phone"
            />
          </v-form>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @apply="apply"
          @cancel="dismiss"
          txtApply="Salvar"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { OrgApi } from '@/models/index.js'

export default {
  computed: {
    // apenas renomeia "value", que é injetado pelo TabbedInterface,
    // para "row", que é o padrão em várias outras telas.
    row() {
      return this.value
    }
  },
  props: {
    value: { required: true }
  },
  data() {
    return { isValid: false, clonedValues: {} }
  },
  methods: {
    async edit() {
      let { login, name, email, phone } = this.value
      this.clonedValues = { login, name, email, phone }
      await this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        this.dismiss()
        this.$rootLoading(async () => {
          let fetcher = new OrgApi(this.value.orgId)
          let old = await fetcher.get(`users/${this.value.id}`)
          Object.assign(old, this.clonedValues)
          await fetcher.put(`users/${this.value.id}`, old)
          this.$snack('Salvo com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
